import { createStore } from 'vuex';
import booking from './modules/booking';

const store = createStore({
    modules: {
        booking,
    },
});

export default store;
